import request from '../utils/request'

// ==================== 自动化测试接口管理 ====================

// 获取接口列表
export function getApiList(params) {
  return request({
    url: '/test_controller/api_list',
    method: 'get',
    params
  })
}

// 获取接口树形列表
export function getApiListTree(params) {
  return request({
    url: '/test_controller/api_list_tree',
    method: 'get',
    params
  })
}

// 获取接口树形列表（懒加载）
export function getApiListLazy(params) {
  return request({
    url: '/test_controller/api_list_lazy',
    method: 'get',
    params
  })
}

// 获取接口详情
export function getApiDetail(params) {
  return request({
    url: '/test_controller/api_detail',
    method: 'get',
    params
  })
}

// 创建接口
export function createApi(data) {
  return request({
    url: '/test_controller/api_add',
    method: 'post',
    data
  })
}

// 更新接口
export function updateApi(data) {
  return request({
    url: '/test_controller/api_update',
    method: 'post',
    data
  })
}

// 删除接口
export function deleteApi(data) {
  return request({
    url: '/test_controller/api_delete',
    method: 'post',
    data
  })
}

// 获取模块列表
export function getModuleList(params) {
  return request({
    url: '/test_controller/module_list',
    method: 'get',
    params
  })
}

// 获取子模块列表
export function getSubModuleList(params) {
  return request({
    url: '/test_controller/sub_module_list',
    method: 'get',
    params
  })
}

// 获取标签列表
export function getTagList(params) {
  return request({
    url: '/test_controller/tag_list',
    method: 'get',
    params
  })
}

// 导出API用例
export function exportApi(params) {
  return request({
    url: '/test_controller/api_export',
    method: 'get',
    params
  })
}

// 导入API用例
export function importApi(data) {
  return request({
    url: '/test_controller/api_import',
    method: 'post',
    data
  })
}

// ==================== 自动化测试报告 ====================

// 执行自动化测试
export function executeTest(data) {
  return request({
    url: '/test_controller/execute_test',
    method: 'post',
    data
  })
}

// 获取测试报告列表
export function getReportList(params) {
  return request({
    url: '/test_controller/report_list',
    method: 'get',
    params
  })
}

// 获取测试报告详情
export function getReportDetail(reportId) {
  return request({
    url: '/test_controller/report_detail',
    method: 'get',
    params: { report_id: reportId }
  })
}

// 删除测试报告
export function deleteReport(reportId) {
  return request({
    url: '/test_controller/report_delete',
    method: 'post',
    data: { report_id: reportId }
  })
}

// 质量门禁检查
export function qualityGateCheck(params) {
  return request({
    url: '/test_controller/quality_gate_check',
    method: 'get',
    params
  })
}

// 获取质量报告
export function getQualityReport(params) {
  return request({
    url: '/test_controller/quality_report',
    method: 'get',
    params
  })
}

// 获取测试进度
export function getTestProgress(reportId) {
  return request({
    url: '/test_controller/test_progress',
    method: 'get',
    params: { report_id: reportId }
  })
}
